<template>
  <div class="order-grid col-sm-12 col-md-12 col-lg-12">
    <div class="header2">
      <h1 class="title">Current Providers</h1>
      <button type="button" @click="showAddProv">
        <font-awesome-icon icon="plus-circle" />
      </button>
      <button type="button" @click="showProviderGroup">Add Provider Group</button>
      <button type="button" @click="GetProviderList">View Provider Group</button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 provcardSec">
      <div class="col-sm-12 col-md-12 col-lg-12 col1">
        <label
          ><input type="text" id="addgroupfield" class="group-inputfield" value="" />Add
          Provider Group Name</label
        >
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 col2">
        <div v-for="(provider, index) in allProvs" :key="'addprovlist' + index">
          <div class="providerGroup-listcard col-md-3">
            <div class="npi-checkbox">
              <label
                ><input
                  v-model="newGroupProvs"
                  type="checkbox"
                  id="provichkbx"
                  :value="provider"
                />{{ provider.npinumber }}</label
              >
            </div>
            <div class="prov-img col-sm-12 col-md-3">
              <img
                src="@/assets/images/avatar-male.jpg"
                id="prov-img"
                width="40"
                height="40"
                title="provider image"
              />
            </div>
            <div class="prov-emailsec col-md-3">
              <p class="names-prov">
                {{ provider.firstname }}&nbsp;&nbsp;{{ provider.lastname }}
              </p>
              <a href="mailto:provider.email" title="Provider Email Information">{{
                provider.email
              }}</a>
              <p class="prov-phone">{{ provider.phone }}</p>
            </div>
          </div>
        </div>
        <!-- <div v-if="!patientContacts || !patientContacts.length">No Contacts Available</div>
                <div v-for="(pContacts, index) in patientContacts" :key="'addteamlist'+index"> 
                   <div class="providerGroup-listcard col-md-3">
                       <div class='npi-checkbox'>
                            <label><input v-model="newGroupEmails" type='checkbox' id="provichkbx" :value="pContacts">{{ pContacts.email }}</label>
                        </div>
                        <div class='prov-img col-sm-12 col-md-3'>
                            <img src="@/assets/images/avatar-male.jpg" id="prov-img" width="40" height="40" title="provider image" />
                        </div>
                        <div class="prov-emailsec col-md-3">
                            <p class="names-prov">{{ pContacts.firstName }}&nbsp;&nbsp;{{ pContacts.firstName }}</p>
                            <a href="mailto:pContacts.email" title="Provider Email Information">{{ pContacts.email }}</a>
                            <p class="prov-phone">{{ pContacts.primaryPhone }}</p>
                        </div>
                       
                   </div> 
                </div>-->
        <div class="addgroup-sec">
          <button
            type="button"
            class="group-btn col-sm-12 col-md-6 col-lg-6"
            id="addgroupbtn"
            @click="AddProviderGroup()"
          >
            Add Provider Gorup
          </button>
          <button
            type="button"
            class="group-btn col-sm-12 col-md-6 col-lg-6"
            id="exitgroupbtn"
            @click="CloseProviderGroup()"
          >
            Close & Exit
          </button>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-12 listGroupSec">
      <div class="card" v-for="(group, index) in groupNumber" :key="'grplist' + index">
        <div class="accordhead">
          <div class="caret">
            <span @click="ShowGroupList(index)" id="accord-caret">+</span>
            <div class="elipsecontainer">
              <div id="elipse" @click="ShowSubNav(index)">...</div>
              <div class="subnavcontainer" :id="'subnav' + index">
                <div class="sub-nav">
                  <a
                    href="#email"
                    :id="'mergeemail' + index"
                    @click="SendGroupEmail(index)"
                    >Send Group Email
                  </a>
                </div>
                <div class="sub-nav">
                  <a
                    href="#textsms"
                    :id="'mergetext' + index"
                    @click="SendGroupText(index)"
                    >Send Group SMS</a
                  >
                </div>
                <div class="sub-nav">
                  <a
                    href="#conftextsms"
                    :id="'mergeconftext' + index"
                    @click="GroupConferenceCall(index)"
                    >Conference Call SMS Group</a
                  >
                </div>
                <div class="sub-nav">
                  <a
                    href="#deletegrp"
                    :id="'deletegrp' + index"
                    @click="DeleteGroup(index)"
                    >Delete Group</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="grp-name">
            <p :key="index" id="gpname">{{ group.groupname }}</p>
          </div>
        </div>

        <div class="accordionbottom" :id="'accordionbottom' + index">
          <div
            v-for="(provlist, index) in group.providerslist"
            :key="'provlist' + index"
            :id="'provminicard' + index"
            class="providminicard col-sm-12 col-md-12 col-lg-12"
          >
            <div class="col-sm-12 col-md-3 col-lg-3">
              <p id="grprovemail">{{ provlist.email }}</p>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">
              <p>{{ provlist.firstname }} {{ provlist.lastname }}</p>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">
              <p id="grpnpi">{{ provlist.npi }}</p>
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">
              <p id="grpphn">{{ provlist.phone }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="smsconferencecanvas">
      <div class="container">
        <form id="smsform">
          <label>To:</label
          ><input type="text" required="required" id="smsconferencephone" /><br />
          <textarea id="smsconferencebox" placeholder="Enter Text Message.."> </textarea
          ><br />
          <input
            type="button"
            class="btn btn-danger"
            value="Send Text Message"
            id="sbmttxtconfbtn"
            @click="SendGroupTextMsg"
          />
          <input
            type="button"
            class="btn btn-danger conf-call-btn"
            value="Send Conference Call"
            id="confcallbtn"
            @click="SendGroupConferenceCall"
          />
          <input
            type="button"
            class="btn btn-dark"
            value="Exit & Close"
            id="closeconfcallbtn"
            @click="CloseGroupConferenceCall"
          />
        </form>
      </div>
    </div>
    <div class="groupemailcecanvas">
      <div class="container">
        <form id="emailform">
          <label>To:</label
          ><input type="text" required="required" id="conferenceEmail" /><br />
          <textarea id="emailconferencebox" placeholder="Enter Email Message"> </textarea
          ><br />
          <input
            type="button"
            class="btn btn-danger"
            value="Send Group Email"
            id="sbmtemailconfbtn"
            @click="SendGroupEmailMsg"
          />
          <input
            type="button"
            class="btn btn-dark"
            value="Cancel"
            id="groupemailcancelbtn"
            @click="CloseGroupEmailMsg"
          />
        </form>
      </div>
    </div>
    <!-- <div class="provmodal col-sm-12 col-md-12 col-lg-12" :id="'provmodal' + patient.id">
            <form :id="'provform' + patient.id" @submit.prevent="saveProv">
                <div class="firstrow">
                    <label for="primphysician" role="text">Physician Name Lookup</label>
                    <input name="primphysician" type="text" placeholder="" id="primphysician" class="phyfield"
                        v-model="npiSearch" @keyup.prevent="showResults" />
                    <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                        <div v-for="(npi, index) in searchedNpis" class="additionalnameli" :key="index + 'npi' + npi.npinumber"
                            @click="selectNpi(npi)">
                            {{ npi.name }}
                        </div>
                    </div>
                </div>
                <div class="secondrow">
                    <label for="phyfirstname" role="text">First Name</label>
                    <input name="phyfirstname" type="text" required id="phyfirstname" class="phyfield" />
                    <label for="phylastname" role="text">Last Name</label>
                    <input name="phylastname" type="text" required id="phylastname" class="phyfield" />
                    <label for="phynpi" role="text">NPI</label>
                    <input name="phynpi" type="text" id="phynpi" class="phyfield" />
                </div>
                <div class="thirdrow">
                    <label for="phyaddr" role="text">Address</label>
                    <input name="phyaddr" type="text" id="phyaddr" class="phyfield" />
                    <div v-if="searchedAddresses" id="npiadditionaladdr" class="npiadditionaladdr">
                        <div v-for="(addr, index) in searchedAddresses" @click="selectAddr(addr)" class="additonaladdrli"
                            :key="index">
                            {{ addr.address }}
                        </div>
                    </div>
                    <label for="phytel" role="text">Tel</label>
                    <input name="phytel" type="text" id="phytel" class="phyfield" />
                    <label for="phycell" role="text">Cell</label>
                    <input name="phycell" type="text" id="phycell" class="phyfield" />
                    <label for="phyfax" role="text">Fax</label>
                    <input name="phyfax" type="text" id="phyfax" class="phyfield" />
                    <label for="phyemail" role="text">Email</label>
                    <input name="phyemail" type="text" id="phyemail" class="phyfield" />
                </div>
                <div class="fourthrow col-sm-12 col-md-4 col-lg-4">
                    <input type="submit" id="saveprovbtn" value="Save" />
                    <input type="button" id="cancelprovbtn" value="Cancel" @click="closeProv" />
                </div>
            </form>
        </div> -->
    <div class="new-prov-modal" :id="'provmodal' + patient.id">
      <form :id="'provform' + patient.id" @submit.prevent="saveProv">
        <div class="form-group">
          <label for="primphysician">Physician Name Lookup</label>
          <input
            name="primphysician"
            type="text"
            id="primphysician"
            class="form-control"
            v-model="npiSearch"
            @keyup.prevent="showResults"
          />
          <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
            <div
              v-for="(npi, index) in searchedNpis"
              class="additionalnameli"
              :key="index + 'npi' + npi.npinumber"
              @click="selectNpi(npi)"
            >
              {{ npi.name }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="phyfirstname">First Name</label>
          <input
            name="phyfirstname"
            type="text"
            required
            id="phyfirstname"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="phylastname">Last Name</label>
          <input
            name="phylastname"
            type="text"
            required
            id="phylastname"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="phynpi">NPI</label>
          <input name="phynpi" type="text" id="phynpi" class="form-control" />
        </div>
        <div class="form-group">
          <label for="phyaddr">Address</label>
          <input name="phyaddr" type="text" id="phyaddr" class="form-control" />
          <div v-if="searchedAddresses" id="npiadditionaladdr" class="npiadditionaladdr">
            <div
              v-for="(addr, index) in searchedAddresses"
              @click="selectAddr(addr)"
              class="additonaladdrli"
              :key="index"
            >
              {{ addr.address }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="phytel">Tel</label>
          <input name="phytel" type="text" id="phytel" class="form-control" />
        </div>
        <div class="form-group">
          <label for="phycell">Cell</label>
          <input name="phycell" type="text" id="phycell" class="form-control" />
        </div>
        <div class="form-group">
          <label for="phyfax">Fax</label>
          <input name="phyfax" type="text" id="phyfax" class="form-control" />
        </div>
        <div class="form-group">
          <label for="phytel">Email</label>
          <input name="phyemail" type="text" id="phyemail" class="form-control" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary">Save</button>
          <button type="button" class="btn btn-secondary" @click="closeProv">
            Cancel
          </button>
        </div>
      </form>
    </div>
    <div v-if="editedProv" :id="'edit-prov-modal-' + patient.id" class="edit-prov-modal">
      <form :id="'edit-prov-form-' + patient.id" @submit.prevent="saveEditProv">
        <div class="form-group">
          <label for="phy-firstname">First Name</label>
          <input
            name="phyfirstname"
            type="text"
            required
            :value="editedProv.firstname"
            id="phy-firstname"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="phy-lastname">Last Name</label>
          <input
            name="phylastname"
            type="text"
            required
            :value="editedProv.lastname"
            id="phy-lastname"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label for="phy-npi">NPI</label>
          <input
            name="phynpi"
            type="text"
            id="phy-npi"
            class="form-control"
            :value="editedProv.npinumber"
          />
        </div>
        <div class="form-group">
          <label for="phy-addr">Address</label>
          <input
            name="phyaddr"
            type="text"
            id="phy-addr"
            class="form-control"
            :value="editedProv.addr1"
          />
        </div>
        <div class="form-group">
          <label for="phy-tel">Tel</label>
          <input
            name="phytel"
            type="text"
            id="phy-tel"
            class="form-control"
            :value="editedProv.tel"
          />
        </div>
        <div class="form-group">
          <label for="phy-cell">Cell</label>
          <input
            name="phycell"
            type="text"
            id="phy-cell"
            class="form-control"
            :value="editedProv.cell"
          />
        </div>
        <div class="form-group">
          <label for="phy-fax">Fax</label>
          <input
            name="phyfax"
            type="text"
            id="phy-fax"
            class="form-control"
            :value="editedProv.fax"
          />
        </div>
        <div class="form-group">
          <label for="phy-tel">Email</label>
          <input
            name="phyemail"
            type="text"
            id="phy-email"
            class="form-control"
            :value="editedProv.email"
          />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary">Save</button>
          <button type="button" class="btn btn-secondary" @click="closeEditProv">
            Cancel
          </button>
        </div>
      </form>
    </div>
    <div
      :id="'send-text-modal-' + patient.id"
      class="send-text-modal"
      :style="{ display: 'none' }"
    >
      <div class="inner-text-modal">
        <div class="form-group">
          <label>Cell Number:</label>
          <input
            type="text"
            required
            :id="'modaltext' + patient.id"
            class="form-control prvtxtbox"
          /><br />
          <label>Enter text body</label>
          <input
            type="text"
            required
            :id="'modalmsg' + patient.id"
            class="form-control prvtxtMsgbox"
          />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary" @click="sendText(patient.id)">
            Send
          </button>
          <button type="button" class="btn btn-secondary" @click="closeText">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <!-- <div
            v-if="editedProv"
            class="editprovmodal col-sm-12 col-md-12 col-lg-12"
            :id="'editprovmodal' + patient.id"
        >
            <form :id="'editprovform' + patient.id" @submit.prevent="saveEditProv">
                <div class="firstrow">
                    <label for="primphysician" role="text">Physician Name Lookup</label>
                    <input
                        name="primphysician"
                        type="text"
                        placeholder=""
                        id="primphysician"
                        class="phyfield"
                        v-model="npiSearch"
                        @keyup.prevent="showResults"
                    />
                    <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                        <div v-for="(npi, index) in searchedNpis" class="additionalnameli" :key="index+'npi'+npi.npinumber" @click="selectNpi(npi)">
                        {{npi.name}}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="newaccextern">ID</label>
                    <input required name="newaccextern" :value="Math.floor(Math.random() * (899999999)) + 100000000"
                        type="text" id="newaccextern" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccfirstname">First Name</label>
                    <input required name="newaccfirstname" :value="addedProv.firstname" type="text" id="newaccfirstname"
                        class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newacclastname">Last Name</label>
                    <input required name="newacclastname" :value="addedProv.lastname" type="text" id="newacclastname"
                        class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccusername">Username</label>
                    <input required name="newaccusername" type="text" id="newaccusername" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccpass">Password</label>
                    <input required name="newaccpass" type="password" id="newaccpass" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccpass2">Confirm Password</label>
                    <input required name="newaccpass2" type="password" id="newaccpass2" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccdob">Date of Birth</label>
                    <input required name="newaccdob" type="date" id="newaccdob" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccgender">Gender</label>
                    <select id="newaccgender" required class="form-control">
                        <option v-for="(gender, index) in genders" :key="'gender-' + index" :value="gender.id">
                            {{ gender.value }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="newaccemail">Email</label>
                    <input required name="newaccemail" :value="addedProv.email" type="text" id="newaccemail"
                        class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newaccaddr">Address</label>
                    <input name="newaccaddr" :value="addedProv.addr1" type="text" id="newaccaddr" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newacctel">Tel</label>
                    <input name="newacctel" :value="addedProv.tel" type="text" id="newacctel" class="form-control" />
                </div>
                <div class="form-group">
                    <label for="newacccell">Cell</label>
                    <input name="newacccell" :value="addedProv.cell" type="text" id="newacccell" class="form-control" />
                </div>
                <div class="btn-group">
                    <button type="submit" class="btn btn-primary">Create</button>
                    <button type="button" class="btn btn-secondary" @click="closeNewProv">Cancel</button>
                </div>
            </form>
        </div>
      -->
    <ul v-if="allProvs" class="result-list">
      <li v-for="(provider, index) in allProvs" :key="index">
        <div class="result-item">
          <h2 class="header3 capitalize">
            <span v-if="provider.firstname">{{ provider.firstname.toLowerCase() }} </span>
            <span v-if="provider.lastname">{{ provider.lastname.toLowerCase() }}</span>
            <div class="modifier-container">
              <button class="modifier-indicator" @click="showMod(index)">...</button>
              <div class="modifier-dropdown" :id="'modifier-dropdown' + index">
                <button class="provbtn edit" @click="showEditProv(provider)">Edit</button>
                <button
                  class="provbtn remove"
                  @click="removeProvider(provider.providerid)"
                >
                  Remove
                </button>
                <button
                  v-if="provider.onTeam != '1'"
                  class="provbtn team"
                  @click="addProviderTeam(provider, index)"
                >
                  Add to Team
                </button>
                <button
                  v-else
                  class="provbtn team"
                  @click="removeProviderTeam(provider, index)"
                >
                  Remove from Team
                </button>
                <!-- <button class="provbtn call" @click="callProvider(provider)">Call</button>
                                <button class="provbtn txt" @click="showTextProv(provider)">Text</button>
                                <button class="provbtn email" @click.self="showEmailModule($event,index,provider)">Email</button>-->
              </div>
            </div>
          </h2>
          <!-- TODO: is it a good idea to pick the first entry?  -->
          <!-- <provider-bio :provider="provider" :specialty="provider.specialties[0].name" :keywords="keywords"></provider-bio> -->
          <div class="emailcanvas" :id="'emailcanvas' + provider.providerid">
            <div class="container">
              <label>Email:<span id="cllprov">Joseph Mulvehill</span></label
              ><br />
              <!--<label>To:</label><input type="text" id="providetomail" class="provid-inputfield"/><br/>-->
              <label>To:</label
              ><input
                type="text"
                :id="'providetomail' + provider.providerid"
                class="provid-inputfield"
              />
              <div class="inputvalholder">
                <!--<li class="emailli">
                                    <div class="emailblock">
                                        <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">keyon5052@gmail.com</a>
                                        <span class="xout">X</span>
                                    </div>
                                </li>
                                <li class="emailli">
                                    <div class="emailblock">
                                        <a href="mailto:keyonwhiteisde@willowmarketing.com" id="emaillink">emailvip52@gmail.com</a>
                                        <span class="xout">X</span>
                                    </div>
                                </li>-->
              </div>
              <ul class="selectbox">
                <!--<li class="emailbox">
                                    <p id="selectemailp">Keyon@gmail.com</p>
                                    <div id="hiddenmail"></div>
                                </li>-->
              </ul>
              <br />
              <label>Subject:</label
              ><input
                type="text"
                :id="'provemailsubject' + provider.providerid"
                class="provid-inputfield"
              /><br />
              <label>Message:</label><br />
              <textarea
                :id="'provid-emailmsg' + provider.providerid"
                placeholder="Provider Message"
              >
              </textarea
              ><br />
              <div class="btn-container">
                <input
                  type="button"
                  class="btn btn-danger"
                  value="Send Email"
                  @click="SendProvEmail(provider, index)"
                  id="sendprovid-emailbtn"
                />
                <input
                  type="button"
                  class="btn btn-secondary"
                  value="Close Email"
                  @click="CloseProvEmail(provider.providerid)"
                  id="closeprovid-emailbtn"
                />
                <input type="hidden" id="sendprovider" value="" />
              </div>
            </div>
          </div>

          <current-provider-bio :provider="provider"></current-provider-bio>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import genders from "@/data/genders";
import axios from "axios";
import { mapGetters } from "vuex";
import $ from "jquery";
import CurrentProviderBio from "../providers/CurrentProviderBio";
import { isNpiExist, register } from "@/api/userApi";
import { post } from "@/store/modules/fsm/index";
import {
  RequestRegistration,
  RegistrationSuccess,
  RegistrationFailure,
  Continue,
} from "@/store/modules/fsm/messages";
import { restElement } from "@babel/types";
import { getContacts } from "@/api/userApi";

export default {
  name: "CurrentProviders",
  data() {
    return {
      genders,
      allProvs: null, // List of providers already saved for patient
      npiSearch: "", // Primary physician search textfield value
      searchedNpis: null, // List of physicians retrieved via npiSearch
      searchedAddresses: null, // List of addresses associated with chosen physician
      editedProv: null, // Provider that is being edited
      textingProv: null,
      txtMsg: "",
      txtPhone: "",
      addedProv: null, // Provider that new account is being made for

      npisAdded: [], // List of npis added for group
      newGroupProvs: [],
      newGroupEmails: [],
      grouplist: [],
      groupNumber: [], //List of Phone numbers
      // patientContacts:null,            //patient contats
      // npi: "",                      // NPI of chosen physician
      // npiAddress: "",               // Address of chosen physician
      // npiPhone: "",                 // Phone number of chosen physician
      // npiFax: "",                   // Fax number of chosen physician
    };
  },
  components: {
    "current-provider-bio": CurrentProviderBio,
  },
  async mounted() {
    this.loadProviders();
    console.log(this.allProvs);
    //this.addProviders();
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patient: function () {
      return this.allData.patient;
    },
    manager: function () {
      return this.allData.manager;
    },
    relationships: function () {
      return this.allData.relationDescriptions;
    },
  },
  methods: {
    showCreateAccount(prov) {
      isNpiExist(prov.npinumber).then((exist) => {
        if (exist) {
          alert("An account with this NPI number already exists.");
          this.addedProv = null;
        } else {
          this.addedProv = prov;
        }
      });
    },
    createAccount() {
      let formData = new FormData(document.getElementById("accform" + this.patient.id));

      let loader = this.$loading.show(
        {},
        {
          after: this.$createElement("div", {}, ["Registering your information..."]),
        }
      );

      let form = {
        isLoggedIn: true,
        admin: true,
        npi: formData.get("newaccnpi"),
        externid: formData.get("newaccextern"),
        first: formData.get("newaccfirstname"),
        middle: "",
        last: formData.get("newacclastname"),
        login: formData.get("newaccusername"),
        password: formData.get("newaccpass"),
        password2: formData.get("newaccpass2"),
        enrollmentId: null,
        dob: formData.get("newaccdob"),
        email: formData.get("newaccemail"),
        ssnHead: "",
        ssnMiddle: "",
        ssnTail: "",
        gender: 1, //   formData.get('newaccgender'), fix for select input
        suffix: null,
        title: null,
        addr: formData.get("newaccaddr"),
        city: "",
        state: "",
        zip: null,
        cell: formData.get("newacccell"),
        work: formData.get("newacctel"),
        home: null,
        ssn: "",
      };

      post({ message: RequestRegistration })
        .then(() => {
          return register(form);
        })
        .then((username) => {
          if (form.isLoggedIn)
            alert(
              `Registration success. The username is: "${username}". Please find the verification code in the submitted email`
            );
          else
            alert(
              `Registration success. The username is: "${username}". Please find the verification code in the submitted email.`
            );
          //TODO: redirect to verification page instead
          post({ message: RegistrationSuccess });
          this.closeNewProv();
        })
        .catch((err) => {
          post({ message: RegistrationFailure });
          alert("Registration failure: " + err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },
    ShowSubNav(index) {
      if ($("#subnav" + index).css("display") == "flex") {
        $("#subnav" + index).css("display", "none");
      } else {
        $("#subnav" + index).css("display", "flex");
      }
    },
    showProviderGroup() {
      if ($(".provcardSec").css("display") == "flex") {
        $(".provcardSec").slideUp("slow");
      } else {
        //close Provider Group
        $(".provcardSec").slideDown("slow");
        $(".provcardSec").css("display", "flex");
        //autommatically close Provider GFroup if its open
        if ($(".listGroupSec").css("display") == "block") {
          $(".listGroupSec").css("display", "none");
        }
      }
    },
    CloseGroupEmailMsg() {
      $(".groupemailcecanvas").slideUp("fast");
    },
    CloseGroupConferenceCall() {
      $(".smsconferencecanvas").slideUp("fast");
    },
    CloseProviderGroup() {
      $(".provcardSec").slideUp("slow");
    },
    SendGroupEmail(index) {
      let tempar = "";
      console.log("clicked");
      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grprovemail").html() != "") {
            //psh into the array
            tempar += $(this).find("#grprovemail").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grprovemail").html());
          }
          //lets show case the sms conference canvas
        });
      $(".groupemailcecanvas").css("display", "block");
      $("#conferenceEmail").val(tempar);
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
    },
    async SendGroupEmailMsg() {
      let content = {
        Provider: {
          API_Meth: "SendProviderEmail",
          toemail: $("#conferenceEmail").val(),
          message: $("#emailconferencebox").val(),
          provider: this.manager.name,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "EmailSent") {
            alert(
              "Emails successfully sent to group " + $("#gpname").html() + " members!"
            );
            //now close SMS Canvas
            $(".groupemailcecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    GroupConferenceCall(index) {
      let tempar = "";
      console.log("clicked");
      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grpphn").html() != "") {
            //psh into the array
            tempar += $(this).find("#grpphn").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grpphn").html());
          }
          //lets show case the sms conference canvas
        });
      //hide the single text btn
      // $("#sbmttxtconfbtn").css("display","none");
      $(".smsconferencecanvas").css("display", "block");
      $("#smsconferencephone").val(tempar);
      let msg =
        "Please Join The Park Avenue Concierge  Medicine Conference Call. Please be patient as the Conference Call will begin once other participatants join the call. Call the following number: 18556730319";
      $("#smsconferencebox").val(msg);
      // $(this).closest(".subnavcontainer").css("display","none");
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
      $("#sbmttxtconfbtn").css("display", "none");
      $("#confcallbtn").css("display", "inline-block");
    },
    async SendGroupConferenceCall() {
      let content = {
        Twilio: {
          API_Meth: "SendConferenceText",
          conferencenumbers: $("#smsconferencephone").val(),
          conferencemessage: $("#smsconferencebox").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.TwilioStatus == "successful") {
            alert(
              "Conference Call successfully sent to group " +
                $("#gpname").html() +
                " members!"
            );
            //now close SMS Canvas
            $("#confcallbtn").css("display", "none");
            $(".smsconferencecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    async SendGroupTextMsg() {
      let content = {
        Twilio: {
          API_Meth: "SendText",
          smsnumber: $("#smsconferencephone").val(),
          smsmessage: $("#smsconferencebox").val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.TwilioStatus == "successful") {
            alert("Text successfully sent to group " + $("#gpname").html() + " members!");
            //now close SMS Canvas
            $(".smsconferencecanvas").css("display", "none");
            // this.groupNumber = res.data.group;
            // this.grouplist = res.data.group.providerslist;
          }
        });
    },
    SendGroupText(index) {
      let tempar = "";

      $("#accordionbottom" + index)
        .find(".providminicard")
        .each(function () {
          console.log("..looping through the mini cards");
          if ($(this).find("#grpphn").html() != "") {
            //psh into the array
            tempar += $(this).find("#grpphn").html() + ",";
          } else {
            console.log("didn't record" + $(this).find("#grpphn").html());
          }
          //lets show case the sms conference canvas
        });
      $(".smsconferencecanvas").css("display", "block");
      $("#smsconferencephone").val(tempar);
      //now close the sub nave
      $("#subnav" + index).css("display", "none");
      $("#smsform").find("#smsconferencebox").val("");
      $("#confcallbtn").css("display", "none");
      $("#sbmttxtconfbtn").css("display", "inline-block");
    },
    ShowGroupList(index) {
      if ($("#accordionbottom" + index).css("display") == "block") {
        $("#accordionbottom" + index).slideUp("slow");
      } else {
        //close the Add Group Section

        $("#accordionbottom" + index).slideDown("slow");
      }
    },
    async DeleteGroup(index) {
      //lets get the group name
      let groupname = $("#deletegrp" + index)
        .closest(".card")
        .find("#gpname")
        .html();
      console.log(groupname);
      let content = {
        Provider: {
          API_Meth: "DeleteProviderGroup",
          accountnumber: this.allData.patient.externId,
          groupowner: this.manager.name,
          groupname: groupname,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status == "200" && res.data.message == "Deleted") {
            alert(
              $("#deletegrp" + index)
                .closest(".card")
                .find("#gpname")
                .html() + " has been successfully deleted!"
            );
          }
        });
    },
    GetProviderList() {
      if ($(".listGroupSec").css("display") == "block") {
        $(".listGroupSec").slideUp("slow");
      } else if ($(".listGroupSec").css("display") == "none") {
        //$(".listGroupSec").slideDown("slow");
        //lets load in case new groups have been added
        //$(".provcardSec").css("display","none");
        $(".provcardSec").slideUp("slow");
        this.showProviderList();
      } else {
        console.log("do nothing");
      }
    },
    async showProviderList() {
      let content = {
        Provider: {
          API_Meth: "GetProviderGroup",
          accountnumber: this.allData.patient.externId,
          groupowner: this.manager.name,
          grouptype: "provider",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.success == "200") {
            //lets bind to listGroupSec div container

            /* $(".listGroupSec").html('');
                    $(".listGroupSec").append(res.data.html);*/
            //lets set the event listener for the elipse buton
            // this.groupNumber.push(res.data.data);

            this.groupNumber = res.data.group;
            this.grouplist = res.data.group.providerslist;

            console.log(this.groupNumber);
            console.log(this.grouplist);
            $(".order-grid").find(".listGroupSec").css("display", "block"); //("slow");
            /* $("#elipse").click(function(event){
                        event.preventDefault();
                        $(".subnavcontainer").css("display","flex");
                       
                    });*/
            /* $(".subnavcontainer").find("#mergetext").click(function(event){
                        event.preventDefault();
                        alert("clicke");
                        $(".smsconferencecanvas").css("display","block");*/
            //now go get the provider that are in the list

            /*let i=0;
                        console.log(event.target.id);
                        console.log($("#"+event.target.id).closest(".card").attr("class"));
                        $("#"+event.target.id).closest(".card").find(".providminicard").each(function(){
                            i++;
                            alert("Hi" +i);
                           this.groupNumber.push($("#grpphn").html());
                           console.log(this.data.groupNumber);
                           console.log($("#grpphn").html());
                           console.log(i +"...Looping"); 
                        });
                        console.log(this.data.groupNumber);
                     });*/
          }
        });
    },
    async loadProviders() {
      let content = {
        Provider: {
          API_Meth: "GetAllProviders",
          patientid: this.allData.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.provider) {
            this.allProvs = res.data.provider;
          } else {
            this.allProvs = null;
          }
        });
    },
    /* addProviders()
        {
            let data = {};
            
           
            getContacts().then((c) => {
                console.log(c);
               /* for(var i=0; i< c;i++)
               {
                data.provider =[
                "{'firstname':"+c[i]['firstName'],
                 "lastname":+c[i]["lastName"],
                 "npi":c[i]["license"],
                "lastname":c[i]]["npinumber"],
                "address":c[i]["address1"],

                ];
               }*/
    /* this.patientContacts =c;
        console.log(this.patientContacts);
        console.log(this.relationships);
            })
        },*/
    async AddProviderGroup() {
      console.log(this.newGroupProvs);
      console.log(this.newGroupEmails);
      console.log("Adding Provider Groupl");
      //lets get the values that we need
      //lets make sure there is a groupName associated with the field and if not send an alert
      if (
        ($("#addgroupfield").val() != "" && this.newGroupProvs != "") ||
        this.newGroupEmails != ""
      ) {
        //ß let npisar =[];
        let mcontent = {
          Provider: {
            API_Meth: "CreateProviderGroup",
            /*npis:$("#provichkbx").each(function(){
                        npisar.push($("#provichkbx").val());
                        console.log(npisar +"Looping..");
                    }),*/
            npis: this.newGroupProvs,
            emails: this.newGroupEmails,
            groupname: $("#addgroupfield").val(), //this.newGroupName
            grouptype: "provider", //grouptype
            groupowner: this.manager.name, //this.manager
            accountnumber: this.allData.patient.externId,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", mcontent, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);

            if (res.status == "200" && res != "") {
              alert($("#addgroupfield").val() + " " + "has been added successfully");
              //close the Add PRovider UI
              $(".provcardSec").css("display", "none");
              console.log(this.res.message);
            }
          });
      } else {
        alert(
          "Please make sure Group Name has a valid entry and or that you've selected a provider to add to the group."
        );
        $("#addgroupfield").attr("placeholder", "Please enter a valid Group Name");
      }
    },
    async SendProvEmail(provider, index) {
      let mcontent = {
        Provider: {
          API_Meth: "SendProviderEmail",
          provider: provider.firstname + " " + provider.lastname,
          subject: $("#provemailsubject" + provider.providerid).val(),
          message: $("#provid-emailmsg" + provider.providerid).val(),
          toemail: $("#providetomail" + provider.providerid).val(),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", mcontent, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          console.log(res.data);
          console.log(res.data.message);

          if (res.data.message && res.data.message == "EmailSent") {
            alert(
              "Email Successfully Sent to Proviver" +
                " " +
                provider.firstname +
                " " +
                provider.lastname
            );
            //now hide the UI
            $("#emailcanvas" + index).css("display", "none");
          }
        });
    },
    CloseProvEmail(pid) {
      $("#emailcanvas" + pid).css("display", "none");
    },
    async showResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: this.npiSearch,
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
          } else this.searchedNpis = res.data;
        });
      // this.stopPreloader()
    },
    async addProviderTeam(provider, index) {
      let content = {
        Provider: {
          API_Meth: "UpdateProviderOnTeam",
          provid: provider.providerid,
          value: 1,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status && res.data.status === "Success") {
            alert(
              provider.firstname +
                " " +
                provider.lastname +
                " has been added to this accounts Team."
            );
            this.loadProviders();
            this.showMod(index);
          } else {
            alert(res.data.status);
          }
        });
    },
    async removeProviderTeam(provider, index) {
      let content = {
        Provider: {
          API_Meth: "UpdateProviderOnTeam",
          provid: provider.providerid,
          value: 0,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status && res.data.status === "Success") {
            alert(
              provider.firstname +
                " " +
                provider.lastname +
                " has been removed from this accounts Team."
            );
            this.loadProviders();
            this.showMod(index);
          } else {
            alert(res.data.status);
          }
        });
    },
    async removeProvider(providerid) {
      if (confirm("Are you sure you want to remove this provider from your list?")) {
        let content = {
          Provider: {
            API_Meth: "DeleteProvider",
            pid: providerid,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.status == "Deleted") {
              this.loadProviders();
            } else {
              alert("Error with provider deletion.");
            }
          });
      }
    },
    async callProvider(provider) {
      if (!this.manager.phone1 && !this.manager.phone2) {
        alert(
          "You have no phone number associated with your account. Please visit your profile page and set one."
        );
      } else {
        let content = {
          Twilio: {
            API_Meth: "SendPhoneCall",
            from: this.manager.phone1 ? this.manager.phone1 : this.manager.phone2,
            callnumber: provider.tel,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.status != "") {
              alert("Connecting call...");
            } else {
              alert("Error connecting call.");
            }
          });
      }
    },
    async sendText(id) {
      let content = {
        Twilio: {
          API_Meth: "SendText",
          smsnumber: $("#modaltext" + id).val(),
          smsmessage: $("#modalmsg" + id).val(), // this.txtMsg
        },
      };
      console.log(content);
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.status != "") {
            alert("Text sent");
            this.closeText();
          } else {
            alert("Error sending text");
          }
        });
    },
    showTextProv(provider) {
      this.textingProv = provider;
      console.log(this.textingProv);
      $("#send-text-modal-" + this.patient.id).css("display", "flex");
    },
    showEmailModule(event, index, provider) {
      console.log(event.target.attributes.class);
      console.log(index);
      console.log(provider);
      console.log($(event.target.attributes.class).closest(".emailcanvas").attr("class"));
      let subject =
        "You have a message from" +
        " " +
        provider.firstname +
        " " +
        provider.lastname +
        ", PLease login into the Pacmny EMR Portal to view message.";
      $("#provemailsubject" + provider.providerid).val(subject);
      let message =
        "Dr. " +
        provider.firstname +
        ",please login to view your message from Park Avenue Concerige Medicine EMR Portal.";
      $("#provid-emailmsg" + provider.providerid).val(message);
      console.log($(".emailcanvas").attr("class"));

      $("#emailcanvas" + provider.providerid).css("display", "block");
      //now lets bind the providers email address to the email input field
      console.log(provider.email);
      $("#providetomail" + provider.providerid).val(provider.email);
    },
    closeText() {
      this.textingProv = null;
      this.txtMsg = "Please visit the PACMNY application.";
      $("#send-text-modal-" + this.patient.id).css("display", "none");
    },
    showAddProv() {
      $(".new-prov-modal").css("display", "flex");
    },
    showEditProv(prov) {
      this.editedProv = prov;
      console.log(this.editedProv);
    },
    showMod(index) {
      if ($("#modifier-dropdown" + index).css("display") == "none")
        $("#modifier-dropdown" + index).css("display", "flex");
      else $("#modifier-dropdown" + index).css("display", "none");
    },
    selectNpi(npi) {
      document.querySelector("#phynpi").value = npi.npinumber;
      let name = npi.name.trim().split(" ");
      document.querySelector("#phyfirstname").value = name[0];
      document.querySelector("#phylastname").value = name[name.length - 1];

      this.searchedNpis = null;
      this.searchedAddresses = npi.addresses;
    },
    async saveProv() {
      let callnumexist = "";
      let isemailValid = "";
      if ($("#phytel").val() != "" || $("#phycell").val() != "") {
        callnumexist = "true";
      } else {
        callnumexist = "false";
      }
      //valdate email
      let re = /^\w+([-+.'][^\s]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

      let emailFormat = re.test($("#phyemail").val()); // This return result in Boolean type
      console.log(emailFormat);
      if (emailFormat) {
        isemailValid = true;
      } else {
        isemailValid = false;
      }
      if (
        $("#phyfirstname").length != 0 &&
        $("#phylastname").length != 0 &&
        $("#phytel").length != 0 &&
        $("#phyemail").length != 0 &&
        isemailValid == true &&
        callnumexist == "true"
      ) {
        let form = document.getElementById("provform" + this.patient.id);
        let modal = document.getElementById("provmodal" + this.patient.id);
        let content = {
          Provider: {
            API_Meth: "AddProvider",
            provFname: form.elements["phyfirstname"].value,
            provLname: form.elements["phylastname"].value,
            provAddr1: form.elements["phyaddr"].value,
            provAddr2: "",
            provCity: "",
            provState: "",
            provZip: "",
            provTel: form.elements["phytel"].value,
            provCell: form.elements["phycell"].value,
            provFax: form.elements["phyfax"].value,
            npinumber: form.elements["phynpi"].value,
            pid: this.patient.externId,
            ordernumber: "999",
            status: "Active",
            provEmail: form.elements["phyemail"].value,
          },
        };
        console.log(content);
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            console.log(res);
            if (res.data.message && res.data.message == "Inserted") {
              this.npiSearch = null;
              this.searchedNpis = null;
              this.searchedAddresses = null;
              this.loadProviders();

              alert("Provider successfully added");
              form.reset();
              modal.style.display = "none";
            } else {
              alert(
                "Error with provider insertion. Try again or contact an administrator."
              );
            }
          });
      } else {
        alert(
          "Please ensure the form field requirements has been met. Please check your entries and try again."
        );
      }
    },
    async saveEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      let content = {
        Provider: {
          API_Meth: "UpdateProvider",
          providerid: this.editedProv.providerid,
          email: "",
          patientid: this.patient.externId,
          ordernumber: "",
          firstname: form.elements["phyfirstname"].value,
          lastname: form.elements["phylastname"].value,
          address1: form.elements["phyaddr"].value,
          address2: "",
          city: "",
          state: "",
          zip: "",
          phone: form.elements["phytel"].value,
          cell: form.elements["phycell"].value,
          email: form.elements["phyemail"].value,
          fax: form.elements["phyfax"].value,
          npinumber: form.elements["phynpi"].value,
          status: "Active",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg && res.data.msg == "Updated") {
            this.loadProviders();
            alert("Provider successfully edited");
            this.editedProv = null;
            // form.style.display = "none"
            // modal.style.display = "none"
          } else {
            alert(res.data[1]);
          }
        });
    },
    selectAddr(addr) {
      document.querySelector("#phyaddr").value = addr.address ? addr.address : "";
      document.querySelector("#phytel").value = addr.tel ? addr.tel : "";
      document.querySelector("#phyfax").value = addr.fax ? addr.fax : "";
      this.searchedAddresses = null;
    },
    closeProv() {
      let form = document.getElementById("provform" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      let modal = document.getElementById("provmodal" + this.patient.id);
      modal.style.display = "none";
    },
    closeEditProv() {
      let form = document.getElementById("edit-prov-form-" + this.patient.id);
      form.reset();
      this.npiSearch = null;
      this.searchedAddresses = null;
      this.searchedNpis = null;
      this.editedProv = null;
      let modal = document.getElementById("edit-prov-modal-" + this.patient.id);
      modal.style.display = "none";
    },
    closeNewProv() {
      let form = document.getElementById("accform" + this.patient.id);
      form.reset();
      this.addedProv = null;
    },
  },
};
</script>
<style scoped lang="scss">
.edit-prov-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-prov-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: none;
  justify-content: center;
  align-items: center;
}

.send-text-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.edit-prov-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.new-prov-modal form {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.inner-text-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
}

.form-control {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: none;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}
.form-control.prvtxtMsgbox {
  border-style: solid;
  border-color: #000000;
  height: 140px;
}
.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}

.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
}

.title {
  margin-right: 20px;
}

.result-list {
  width: 700px;
}

.result-item {
  border: 1px solid lightgray;
  border-radius: 5px;
  margin: 2em auto 0;
  text-align: left;
}

.result-item:first-child {
  margin-top: 1em;
}

.header3 {
  text-align: center;
  color: #fff;
  font-size: 1.2em;
  padding: 5px 0;
  background-color: #007bff;
}

.capitalize {
  text-transform: capitalize;
}

.result-item-link {
  display: block;
  text-align: right;
  font-size: 0.85em;
}

ul {
  list-style-type: none;
  margin: 0 auto;
}
.providerGroup-listcard {
  display: flex;
  justify-content: space-evenly;
  border-style: dashed;
  border-width: 1px;
  width: 100%;
}
/*Keyon Add Provider CSS*/
.provcardSec {
  display: none;
  align-items: center;
  position: relative;
  flex-direction: column;
}
.emailcanvas {
  display: none;
}

#cllprov {
  margin-left: 20px;
}
#providetomail {
  margin-left: 30px;
}
#provemailsubject {
  margin-left: 30px;
}
#provid-emailmsg {
  margin-left: 30px;
  margin-top: -10px;
  margin-bottom: 10px;
  width: 400px;
  height: 100px;
}
#sendprovid-emailbtn {
  margin-left: 30px;
}
.emailcanvas .container {
  box-shadow: 1px 1px 9px #5f5852;
  position: absolute;
  background-color: #ffffff;
  width: 855px;
  height: auto; // 710px;
  padding-bottom: 20px;
  margin: 0 auto;
}
.emailcanvas .btn-container {
  padding-bottom: 30px;
}
.emailcanvas label {
  margin-bottom: 20px;
}
#providetomail {
  margin-left: 30px;
}
.emailcanvas ul {
  display: flex;
  margin-top: -64px;
}
.emailcanvas .emailli {
  list-style: none;
  margin-left: 20px;
}
.emailcanvas .emailblock {
  background-color: #aaabac;
  padding: 5px 5px;
  width: auto;
  height: auto;
  margin-left: 12px;
  position: relative;
  top: 17px;
}
.emailcanvas .xout {
  background-color: white;
  cursor: pointer;
}
.mmailbox {
  background-color: #55555512;
  width: 100%;
  position: relative;
  z-index: 3000000000;
  top: -35px;
}
.mmailbox #hiddenmail {
  display: none;
}
.emailcanvas .selectbox {
  margin-top: -10px;
}
.inputvalholder {
  display: none;
  justify-content: flex-start;
}
.listGroupSec {
  display: none;
}
.listGroupSec .card .accordhead {
  display: flex;
  flex-direction: row-reverse;
  border-style: solid;
  border-width: 1px;
  border-color: #606565b0;
}
.listGroupSec .card .caret {
  text-align: right;
  width: 100px;
}
.listGroupSec .card .grp-name {
  width: 100%;
  margin: 0 auto;
}
.listGroupSec .card .grp-name p {
  text-align: center;
}
.listGroupSec .accordionbottom {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-style: solid;
  border-width: 1px;
  border-color: #0433;
  display: flex;
}
.listGroupSec .providminicard {
  display: flex;
  flex-direction: row-reverse;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  flex-direction: row-reverse;
  padding: 11px;
  margin-bottom: 3px;
}
.listGroupSec #accord-caret {
  cursor: pointer;
}
.listGroupSec #accord-caret:hover {
  color: #4553;
}
.listGroupSec .groupcanvas .card {
  display: flex;
  flex-direction: column;
}
.listGroupSec .subnavcontainer {
  display: none;
  flex-direction: column;
  width: 248px;
  margin-left: -153px;
  border-style: ridge;
  padding: 11px;
}
.listGroupSec #elipse {
  cursor: pointer;
}
.listGroupSec .closecanvas {
  display: none;
}
.listGroupSec .creategrpcanvas {
  display: none;
}
.listGroupSec .groupcanvas {
  display: none;
}
.accordionbottom {
  display: none;
}
.smsconferencecanvas {
  display: none;
}
.listGroupSec .accordionbottom {
  display: none;
}
.groupemailcecanvas {
  display: none;
}
#sbmttxtconfbtn {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-right: 20px;
}
#smsconferencebox {
  width: 650px;
  height: 220px;
}
#smsconferencephone {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
.smsconferencecanvas .container {
  padding: 10px;
  display: flex;
  text-align: center;
}
.groupemailcecanvas .container {
  padding: 10px 100px;
  display: flex;
  text-align: center;
}
#emailform {
  border-style: solid;
  border-width: 1px;
  border-color: #003330;
}
#conferenceEmail {
  width: 425px;
  height: 45px;
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
}
#emailconferencebox {
  width: 650px;
  height: 220px;
}
#sbmtemailconfbtn {
  margin-top: 15px;
  margin-bottom: 15px;
}
.smsconferencecanvas #closeconfcallbtn {
  margin-left: 15px;
}
#groupemailcancelbtn {
  margin-left: 15px;
}
.prvtxtbox {
  height: 42px;
}
/*End Keyon Provider CSS*/
@media only screen and (min-width: 1024px) {
}
@media only screen and (min-width: 1024px) {
  #provid-emailmsg {
    width: 400px;
  }
  .result-list .emailcanvas .container {
    width: 655px;
  }
  .groupemailcecanvas .container {
    padding: 10px 100px;
  }
  #conferenceEmail {
    margin: 20px;
  }
  #emailconferencebox {
    width: 100%;
  }
  .icon .desktopTel {
    display: flex;
  }
  .icon .mobileTel {
    display: none;
  }
  .emailcanvas .container textarea {
    width: 485px;
    height: 175px;
  }
  #smsconferencebox {
    width: 650px;
  }
  #smsconferencephone {
    width: 425px;
    margin: 20px;
  }
}
@media only screen and (max-width: 768px) {
  .result-list {
    width: 100%;
  }
}
@media only screen and (min-width: 360px) {
  #smsconferencephone {
    width: 100%;
    margin: 0px;
  }
  #smsconferencebox {
    width: 100%;
  }
  .d-option {
    display: none;
  }
  .icon .desktopTel {
    display: none;
  }
  .icon .mobileTel {
    display: flex;
  }
  #provid-emailmsg {
    width: 280px;
  }
  .emailcanvas .container {
    width: 340px;
  }
  .groupemailcecanvas .container {
    padding: 0px;
  }
  #conferenceEmail {
    margin: 10px 0px;
    width: 100%;
  }
  #emailconferencebox {
    width: 100%;
  }
}
</style>
